/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CustomQueryOptions,
  DefaultBodyType,
  FetchError,
  HttpResponseResolver,
  PathParams,
  QueryStringFormat,
  UseMutationOptions,
  UseQueryOptions,
  fetcher,
  http,
  useMutation,
  useQuery,
  useQueryClient,
} from "@oaknorth/util-rest";
import { Scope } from "@oaknorth/util-testing-library";
import { useAccessToken } from "@oaknorth/util-user";
import type { SetOptional } from "type-fest";

import {
  CIScorecard,
  CIScorecardDrilldown,
  CREPropertyType,
  CREScorecard,
  CREScorecardSectorDrilldown,
  CheckoutRequest,
  ClimateScenario,
  ClimateScorecardUser,
  ConfigurationOptions,
  CreateTrialRequest,
  HTTPValidationError,
  RedirectResponse,
  TenantInformation,
} from "./data-contracts";

export type TenantInformationError = FetchError;

function buildTenantInformationQueryKey(): [string] | [string, unknown] {
  const path = `/api/polaris/api/climate-scorecard/v1/tenant-information`;

  return [path];
}

/**
 * No description
 *
 * @name TenantInformation
 * @summary Is Scorecard Tenant
 * @request GET:/climate-scorecard/v1/tenant-information
 * @response `200` `TenantInformation` Successful Response
 */
export function useQueryTenantInformation(
  options: Omit<
    UseQueryOptions<TenantInformation, TenantInformationError>,
    "queryKey" | "queryFn"
  > &
    CustomQueryOptions<TenantInformation> = {},
) {
  const accessToken = useAccessToken();
  const queryKey = buildTenantInformationQueryKey();
  const [path] = queryKey;
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useQuery<TenantInformation, TenantInformationError, TenantInformation>(
    {
      ...queryOptions,
      queryKey,
      queryFn: () =>
        fetcher<TenantInformation>({
          url: path,
          headers: accessToken
            ? {
                Authorization: `Bearer ${accessToken}`,
                ...headers,
              }
            : headers,
          ...fetcherOptions,
        }),
    },
  );
}

/**
 * Hook to imperatively trigger the TenantInformation query
 * @name TenantInformation
 * @summary Is Scorecard Tenant
 * @request GET:/climate-scorecard/v1/tenant-information
 * @response `200` `TenantInformation` Successful Response
 */
export function useLazyQueryTenantInformation(
  options: UseMutationOptions<TenantInformation, TenantInformationError, void> &
    CustomQueryOptions<TenantInformation> = {},
) {
  const accessToken = useAccessToken();
  const { headers, ...queryOptions } = options;
  const { mutate, mutateAsync, ...mutation } = useMutation({
    ...queryOptions,
    mutationFn: () => {
      const [path] = buildTenantInformationQueryKey();
      return fetcher<TenantInformation>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
      });
    },
  });
  return {
    ...mutation,
    execute: mutate,
    executeAsync: mutateAsync,
  };
}

/**
 * Hook returning a function to invalidate data from `useQueryTenantInformation` (e.g. after a mutation)
 *
 * query string variables are optional to allow inexact invalidation
 */
export function useInvalidateQueryTenantInformation() {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: buildTenantInformationQueryKey(),
    });
}

/**
 * Hook returning a function to update the data for `useQueryTenantInformation` (e.g. after a mutation)
 */
export function useUpdateQueryTenantInformation() {
  const queryClient = useQueryClient();
  return (
    data:
      | TenantInformation
      | undefined
      | ((
          oldData: TenantInformation | undefined,
        ) => TenantInformation | undefined),
  ) => queryClient.setQueryData(buildTenantInformationQueryKey(), data);
}

/**
 * Returns a function that will mock the http request made in `useQueryTenantInformation` using using nock.
 * Pass any query or path parameters as well as the mock response and status
 */
export function getMockTenantInformation({
  status,
  response,
}: {
  status: number;
  response: TenantInformation | TenantInformationError;
}): (scope: Scope) => Scope {
  const [path] = buildTenantInformationQueryKey();

  return (scope: Scope) => {
    return scope.get(path).reply(status, response || undefined);
  };
}

/**
 * MSW mock handler for `useQueryTenantInformation`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswTenantInformation(
 *   ({ request }) => HttpResponse.json({ result: "ok" })
 * );
 */
export function getMockMswTenantInformation(
  handler: HttpResponseResolver<
    PathParams,
    DefaultBodyType,
    TenantInformation | null | TenantInformationError
  >,
  options: Parameters<typeof http.get>[2] = {},
) {
  const [path] = buildTenantInformationQueryKey();
  return http.get<
    PathParams,
    DefaultBodyType,
    TenantInformation | null | TenantInformationError
  >(path, handler, options);
}

export type ScorecardUserInfoError = FetchError;

function buildScorecardUserInfoQueryKey(): [string] | [string, unknown] {
  const path = `/api/polaris/api/climate-scorecard/v1/get-scorecard-user-info`;

  return [path];
}

/**
 * @description Return information about the logged in user's Climate Scorecard subscription
 *
 * @name ScorecardUserInfo
 * @summary Get Scorecard User Info
 * @request GET:/climate-scorecard/v1/get-scorecard-user-info
 * @response `200` `ClimateScorecardUser` Successful Response
 */
export function useQueryScorecardUserInfo(
  options: Omit<
    UseQueryOptions<ClimateScorecardUser, ScorecardUserInfoError>,
    "queryKey" | "queryFn"
  > &
    CustomQueryOptions<ClimateScorecardUser> = {},
) {
  const accessToken = useAccessToken();
  const queryKey = buildScorecardUserInfoQueryKey();
  const [path] = queryKey;
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useQuery<
    ClimateScorecardUser,
    ScorecardUserInfoError,
    ClimateScorecardUser
  >({
    ...queryOptions,
    queryKey,
    queryFn: () =>
      fetcher<ClimateScorecardUser>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        ...fetcherOptions,
      }),
  });
}

/**
 * Hook to imperatively trigger the ScorecardUserInfo query
 * @name ScorecardUserInfo
 * @summary Get Scorecard User Info
 * @request GET:/climate-scorecard/v1/get-scorecard-user-info
 * @response `200` `ClimateScorecardUser` Successful Response
 */
export function useLazyQueryScorecardUserInfo(
  options: UseMutationOptions<
    ClimateScorecardUser,
    ScorecardUserInfoError,
    void
  > &
    CustomQueryOptions<ClimateScorecardUser> = {},
) {
  const accessToken = useAccessToken();
  const { headers, ...queryOptions } = options;
  const { mutate, mutateAsync, ...mutation } = useMutation({
    ...queryOptions,
    mutationFn: () => {
      const [path] = buildScorecardUserInfoQueryKey();
      return fetcher<ClimateScorecardUser>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
      });
    },
  });
  return {
    ...mutation,
    execute: mutate,
    executeAsync: mutateAsync,
  };
}

/**
 * Hook returning a function to invalidate data from `useQueryScorecardUserInfo` (e.g. after a mutation)
 *
 * query string variables are optional to allow inexact invalidation
 */
export function useInvalidateQueryScorecardUserInfo() {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: buildScorecardUserInfoQueryKey(),
    });
}

/**
 * Hook returning a function to update the data for `useQueryScorecardUserInfo` (e.g. after a mutation)
 */
export function useUpdateQueryScorecardUserInfo() {
  const queryClient = useQueryClient();
  return (
    data:
      | ClimateScorecardUser
      | undefined
      | ((
          oldData: ClimateScorecardUser | undefined,
        ) => ClimateScorecardUser | undefined),
  ) => queryClient.setQueryData(buildScorecardUserInfoQueryKey(), data);
}

/**
 * Returns a function that will mock the http request made in `useQueryScorecardUserInfo` using using nock.
 * Pass any query or path parameters as well as the mock response and status
 */
export function getMockScorecardUserInfo({
  status,
  response,
}: {
  status: number;
  response: ClimateScorecardUser | ScorecardUserInfoError;
}): (scope: Scope) => Scope {
  const [path] = buildScorecardUserInfoQueryKey();

  return (scope: Scope) => {
    return scope.get(path).reply(status, response || undefined);
  };
}

/**
 * MSW mock handler for `useQueryScorecardUserInfo`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswScorecardUserInfo(
 *   ({ request }) => HttpResponse.json({ result: "ok" })
 * );
 */
export function getMockMswScorecardUserInfo(
  handler: HttpResponseResolver<
    PathParams,
    DefaultBodyType,
    ClimateScorecardUser | null | ScorecardUserInfoError
  >,
  options: Parameters<typeof http.get>[2] = {},
) {
  const [path] = buildScorecardUserInfoQueryKey();
  return http.get<
    PathParams,
    DefaultBodyType,
    ClimateScorecardUser | null | ScorecardUserInfoError
  >(path, handler, options);
}

export type CreScenarioPropertyTypeError = FetchError<HTTPValidationError>;

export type CreScenarioPropertyTypeVariables = {
  query?: never;
  path: { scenario: ClimateScenario; propertyType: CREPropertyType };
};

function buildCreScenarioPropertyTypeQueryKey(
  variables: SetOptional<CreScenarioPropertyTypeVariables, "query">,
): [string] | [string, unknown] {
  const { scenario, propertyType } = variables.path;
  const path = `/api/polaris/api/climate-scorecard/cre/v1/${scenario}/${propertyType}`;

  if (variables.query) {
    return [path, variables.query];
  }
  return [path];
}

/**
 * No description
 *
 * @name CreScenarioPropertyType
 * @summary Get Scorecard Cre
 * @request GET:/climate-scorecard/cre/v1/{scenario}/{property_type}
 * @response `200` `CREScorecard` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useQueryCreScenarioPropertyType(
  variables: CreScenarioPropertyTypeVariables,
  options: Omit<
    UseQueryOptions<CREScorecard, CreScenarioPropertyTypeError>,
    "queryKey" | "queryFn"
  > &
    CustomQueryOptions<CREScorecard> = {},
) {
  const accessToken = useAccessToken();
  const queryKey = buildCreScenarioPropertyTypeQueryKey(variables);
  const [path] = queryKey;
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useQuery<CREScorecard, CreScenarioPropertyTypeError, CREScorecard>({
    ...queryOptions,
    queryKey,
    queryFn: () =>
      fetcher<CREScorecard>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
        ...fetcherOptions,
      }),
  });
}

/**
 * Hook to imperatively trigger the CreScenarioPropertyType query
 * @name CreScenarioPropertyType
 * @summary Get Scorecard Cre
 * @request GET:/climate-scorecard/cre/v1/{scenario}/{property_type}
 * @response `200` `CREScorecard` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useLazyQueryCreScenarioPropertyType(
  options: UseMutationOptions<
    CREScorecard,
    CreScenarioPropertyTypeError,
    CreScenarioPropertyTypeVariables
  > &
    CustomQueryOptions<CREScorecard> = {},
) {
  const accessToken = useAccessToken();
  const { headers, ...queryOptions } = options;
  const { mutate, mutateAsync, ...mutation } = useMutation({
    ...queryOptions,
    mutationFn: (variables: CreScenarioPropertyTypeVariables) => {
      const [path] = buildCreScenarioPropertyTypeQueryKey(variables);
      return fetcher<CREScorecard>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
      });
    },
  });
  return {
    ...mutation,
    execute: mutate,
    executeAsync: mutateAsync,
  };
}

/**
 * Hook returning a function to invalidate data from `useQueryCreScenarioPropertyType` (e.g. after a mutation)
 *
 * query string variables are optional to allow inexact invalidation
 */
export function useInvalidateQueryCreScenarioPropertyType() {
  const queryClient = useQueryClient();
  return (variables: SetOptional<CreScenarioPropertyTypeVariables, "query">) =>
    queryClient.invalidateQueries({
      queryKey: buildCreScenarioPropertyTypeQueryKey(variables),
    });
}

/**
 * Hook returning a function to update the data for `useQueryCreScenarioPropertyType` (e.g. after a mutation)
 */
export function useUpdateQueryCreScenarioPropertyType() {
  const queryClient = useQueryClient();
  return (
    variables: CreScenarioPropertyTypeVariables,
    data:
      | CREScorecard
      | undefined
      | ((oldData: CREScorecard | undefined) => CREScorecard | undefined),
  ) =>
    queryClient.setQueryData(
      buildCreScenarioPropertyTypeQueryKey(variables),
      data,
    );
}

/**
 * Returns a function that will mock the http request made in `useQueryCreScenarioPropertyType` using using nock.
 * Pass any query or path parameters as well as the mock response and status
 */
export function getMockCreScenarioPropertyType({
  variables,
  status,
  response,
}: {
  variables: CreScenarioPropertyTypeVariables;
  status: number;
  response: CREScorecard | CreScenarioPropertyTypeError;
}): (scope: Scope) => Scope {
  const [path] = buildCreScenarioPropertyTypeQueryKey(variables);

  if (variables.query) {
    return (scope: Scope) => {
      return scope
        .get(path)
        .query(variables)
        .reply(status, response || undefined);
    };
  }

  return (scope: Scope) => {
    return scope.get(path).reply(status, response || undefined);
  };
}

/**
 * MSW mock handler for `useQueryCreScenarioPropertyType`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param variables Path/query parameters for the endpoint.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswCreScenarioPropertyType(
 *   ({ request }) => HttpResponse.json({ result: "ok" }),
 *   { path: { id: "123" }}
 * );
 */
export function getMockMswCreScenarioPropertyType(
  handler: HttpResponseResolver<
    { [K in keyof CreScenarioPropertyTypeVariables["path"]]: string },
    DefaultBodyType,
    CREScorecard | null | CreScenarioPropertyTypeError
  >,
  variables: SetOptional<CreScenarioPropertyTypeVariables, "query">,
  options: Parameters<typeof http.get>[2] = {},
) {
  const [path] = buildCreScenarioPropertyTypeQueryKey(variables);
  return http.get<
    { [K in keyof CreScenarioPropertyTypeVariables["path"]]: string },
    DefaultBodyType,
    CREScorecard | null | CreScenarioPropertyTypeError
  >(path, handler, options);
}

export type CreScenarioPropertyTypeStateDrilldownError =
  FetchError<HTTPValidationError>;

export type CreScenarioPropertyTypeStateDrilldownVariables = {
  query?: never;
  path: {
    scenario: ClimateScenario;
    propertyType: CREPropertyType;
    state: string;
  };
};

function buildCreScenarioPropertyTypeStateDrilldownQueryKey(
  variables: SetOptional<
    CreScenarioPropertyTypeStateDrilldownVariables,
    "query"
  >,
): [string] | [string, unknown] {
  const { scenario, propertyType, state } = variables.path;
  const path = `/api/polaris/api/climate-scorecard/cre/v1/${scenario}/${propertyType}/state-drilldown/${state}`;

  if (variables.query) {
    return [path, variables.query];
  }
  return [path];
}

/**
 * No description
 *
 * @name CreScenarioPropertyTypeStateDrilldown
 * @summary Get Scorecard Cre State Drilldown
 * @request GET:/climate-scorecard/cre/v1/{scenario}/{property_type}/state-drilldown/{state}
 * @response `200` `CREScorecardSectorDrilldown` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useQueryCreScenarioPropertyTypeStateDrilldown(
  variables: CreScenarioPropertyTypeStateDrilldownVariables,
  options: Omit<
    UseQueryOptions<
      CREScorecardSectorDrilldown,
      CreScenarioPropertyTypeStateDrilldownError
    >,
    "queryKey" | "queryFn"
  > &
    CustomQueryOptions<CREScorecardSectorDrilldown> = {},
) {
  const accessToken = useAccessToken();
  const queryKey =
    buildCreScenarioPropertyTypeStateDrilldownQueryKey(variables);
  const [path] = queryKey;
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useQuery<
    CREScorecardSectorDrilldown,
    CreScenarioPropertyTypeStateDrilldownError,
    CREScorecardSectorDrilldown
  >({
    ...queryOptions,
    queryKey,
    queryFn: () =>
      fetcher<CREScorecardSectorDrilldown>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
        ...fetcherOptions,
      }),
  });
}

/**
 * Hook to imperatively trigger the CreScenarioPropertyTypeStateDrilldown query
 * @name CreScenarioPropertyTypeStateDrilldown
 * @summary Get Scorecard Cre State Drilldown
 * @request GET:/climate-scorecard/cre/v1/{scenario}/{property_type}/state-drilldown/{state}
 * @response `200` `CREScorecardSectorDrilldown` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useLazyQueryCreScenarioPropertyTypeStateDrilldown(
  options: UseMutationOptions<
    CREScorecardSectorDrilldown,
    CreScenarioPropertyTypeStateDrilldownError,
    CreScenarioPropertyTypeStateDrilldownVariables
  > &
    CustomQueryOptions<CREScorecardSectorDrilldown> = {},
) {
  const accessToken = useAccessToken();
  const { headers, ...queryOptions } = options;
  const { mutate, mutateAsync, ...mutation } = useMutation({
    ...queryOptions,
    mutationFn: (variables: CreScenarioPropertyTypeStateDrilldownVariables) => {
      const [path] =
        buildCreScenarioPropertyTypeStateDrilldownQueryKey(variables);
      return fetcher<CREScorecardSectorDrilldown>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
      });
    },
  });
  return {
    ...mutation,
    execute: mutate,
    executeAsync: mutateAsync,
  };
}

/**
 * Hook returning a function to invalidate data from `useQueryCreScenarioPropertyTypeStateDrilldown` (e.g. after a mutation)
 *
 * query string variables are optional to allow inexact invalidation
 */
export function useInvalidateQueryCreScenarioPropertyTypeStateDrilldown() {
  const queryClient = useQueryClient();
  return (
    variables: SetOptional<
      CreScenarioPropertyTypeStateDrilldownVariables,
      "query"
    >,
  ) =>
    queryClient.invalidateQueries({
      queryKey: buildCreScenarioPropertyTypeStateDrilldownQueryKey(variables),
    });
}

/**
 * Hook returning a function to update the data for `useQueryCreScenarioPropertyTypeStateDrilldown` (e.g. after a mutation)
 */
export function useUpdateQueryCreScenarioPropertyTypeStateDrilldown() {
  const queryClient = useQueryClient();
  return (
    variables: CreScenarioPropertyTypeStateDrilldownVariables,
    data:
      | CREScorecardSectorDrilldown
      | undefined
      | ((
          oldData: CREScorecardSectorDrilldown | undefined,
        ) => CREScorecardSectorDrilldown | undefined),
  ) =>
    queryClient.setQueryData(
      buildCreScenarioPropertyTypeStateDrilldownQueryKey(variables),
      data,
    );
}

/**
 * Returns a function that will mock the http request made in `useQueryCreScenarioPropertyTypeStateDrilldown` using using nock.
 * Pass any query or path parameters as well as the mock response and status
 */
export function getMockCreScenarioPropertyTypeStateDrilldown({
  variables,
  status,
  response,
}: {
  variables: CreScenarioPropertyTypeStateDrilldownVariables;
  status: number;
  response:
    | CREScorecardSectorDrilldown
    | CreScenarioPropertyTypeStateDrilldownError;
}): (scope: Scope) => Scope {
  const [path] = buildCreScenarioPropertyTypeStateDrilldownQueryKey(variables);

  if (variables.query) {
    return (scope: Scope) => {
      return scope
        .get(path)
        .query(variables)
        .reply(status, response || undefined);
    };
  }

  return (scope: Scope) => {
    return scope.get(path).reply(status, response || undefined);
  };
}

/**
 * MSW mock handler for `useQueryCreScenarioPropertyTypeStateDrilldown`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param variables Path/query parameters for the endpoint.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswCreScenarioPropertyTypeStateDrilldown(
 *   ({ request }) => HttpResponse.json({ result: "ok" }),
 *   { path: { id: "123" }}
 * );
 */
export function getMockMswCreScenarioPropertyTypeStateDrilldown(
  handler: HttpResponseResolver<
    {
      [K in keyof CreScenarioPropertyTypeStateDrilldownVariables["path"]]: string;
    },
    DefaultBodyType,
    | CREScorecardSectorDrilldown
    | null
    | CreScenarioPropertyTypeStateDrilldownError
  >,
  variables: SetOptional<
    CreScenarioPropertyTypeStateDrilldownVariables,
    "query"
  >,
  options: Parameters<typeof http.get>[2] = {},
) {
  const [path] = buildCreScenarioPropertyTypeStateDrilldownQueryKey(variables);
  return http.get<
    {
      [K in keyof CreScenarioPropertyTypeStateDrilldownVariables["path"]]: string;
    },
    DefaultBodyType,
    | CREScorecardSectorDrilldown
    | null
    | CreScenarioPropertyTypeStateDrilldownError
  >(path, handler, options);
}

export type CiScenarioAggregationLevelOverviewError =
  FetchError<HTTPValidationError>;

export type CiScenarioAggregationLevelOverviewVariables = {
  query?: never;
  path: { scenario: ClimateScenario; aggregationLevel: number };
};

function buildCiScenarioAggregationLevelOverviewQueryKey(
  variables: SetOptional<CiScenarioAggregationLevelOverviewVariables, "query">,
): [string] | [string, unknown] {
  const { scenario, aggregationLevel } = variables.path;
  const path = `/api/polaris/api/climate-scorecard/ci/v1/${scenario}/${aggregationLevel}/overview`;

  if (variables.query) {
    return [path, variables.query];
  }
  return [path];
}

/**
 * No description
 *
 * @name CiScenarioAggregationLevelOverview
 * @summary Get Scorecard Ci Overview
 * @request GET:/climate-scorecard/ci/v1/{scenario}/{aggregation_level}/overview
 * @response `200` `CIScorecard` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useQueryCiScenarioAggregationLevelOverview(
  variables: CiScenarioAggregationLevelOverviewVariables,
  options: Omit<
    UseQueryOptions<CIScorecard, CiScenarioAggregationLevelOverviewError>,
    "queryKey" | "queryFn"
  > &
    CustomQueryOptions<CIScorecard> = {},
) {
  const accessToken = useAccessToken();
  const queryKey = buildCiScenarioAggregationLevelOverviewQueryKey(variables);
  const [path] = queryKey;
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useQuery<
    CIScorecard,
    CiScenarioAggregationLevelOverviewError,
    CIScorecard
  >({
    ...queryOptions,
    queryKey,
    queryFn: () =>
      fetcher<CIScorecard>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
        ...fetcherOptions,
      }),
  });
}

/**
 * Hook to imperatively trigger the CiScenarioAggregationLevelOverview query
 * @name CiScenarioAggregationLevelOverview
 * @summary Get Scorecard Ci Overview
 * @request GET:/climate-scorecard/ci/v1/{scenario}/{aggregation_level}/overview
 * @response `200` `CIScorecard` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useLazyQueryCiScenarioAggregationLevelOverview(
  options: UseMutationOptions<
    CIScorecard,
    CiScenarioAggregationLevelOverviewError,
    CiScenarioAggregationLevelOverviewVariables
  > &
    CustomQueryOptions<CIScorecard> = {},
) {
  const accessToken = useAccessToken();
  const { headers, ...queryOptions } = options;
  const { mutate, mutateAsync, ...mutation } = useMutation({
    ...queryOptions,
    mutationFn: (variables: CiScenarioAggregationLevelOverviewVariables) => {
      const [path] = buildCiScenarioAggregationLevelOverviewQueryKey(variables);
      return fetcher<CIScorecard>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
      });
    },
  });
  return {
    ...mutation,
    execute: mutate,
    executeAsync: mutateAsync,
  };
}

/**
 * Hook returning a function to invalidate data from `useQueryCiScenarioAggregationLevelOverview` (e.g. after a mutation)
 *
 * query string variables are optional to allow inexact invalidation
 */
export function useInvalidateQueryCiScenarioAggregationLevelOverview() {
  const queryClient = useQueryClient();
  return (
    variables: SetOptional<
      CiScenarioAggregationLevelOverviewVariables,
      "query"
    >,
  ) =>
    queryClient.invalidateQueries({
      queryKey: buildCiScenarioAggregationLevelOverviewQueryKey(variables),
    });
}

/**
 * Hook returning a function to update the data for `useQueryCiScenarioAggregationLevelOverview` (e.g. after a mutation)
 */
export function useUpdateQueryCiScenarioAggregationLevelOverview() {
  const queryClient = useQueryClient();
  return (
    variables: CiScenarioAggregationLevelOverviewVariables,
    data:
      | CIScorecard
      | undefined
      | ((oldData: CIScorecard | undefined) => CIScorecard | undefined),
  ) =>
    queryClient.setQueryData(
      buildCiScenarioAggregationLevelOverviewQueryKey(variables),
      data,
    );
}

/**
 * Returns a function that will mock the http request made in `useQueryCiScenarioAggregationLevelOverview` using using nock.
 * Pass any query or path parameters as well as the mock response and status
 */
export function getMockCiScenarioAggregationLevelOverview({
  variables,
  status,
  response,
}: {
  variables: CiScenarioAggregationLevelOverviewVariables;
  status: number;
  response: CIScorecard | CiScenarioAggregationLevelOverviewError;
}): (scope: Scope) => Scope {
  const [path] = buildCiScenarioAggregationLevelOverviewQueryKey(variables);

  if (variables.query) {
    return (scope: Scope) => {
      return scope
        .get(path)
        .query(variables)
        .reply(status, response || undefined);
    };
  }

  return (scope: Scope) => {
    return scope.get(path).reply(status, response || undefined);
  };
}

/**
 * MSW mock handler for `useQueryCiScenarioAggregationLevelOverview`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param variables Path/query parameters for the endpoint.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswCiScenarioAggregationLevelOverview(
 *   ({ request }) => HttpResponse.json({ result: "ok" }),
 *   { path: { id: "123" }}
 * );
 */
export function getMockMswCiScenarioAggregationLevelOverview(
  handler: HttpResponseResolver<
    {
      [K in keyof CiScenarioAggregationLevelOverviewVariables["path"]]: string;
    },
    DefaultBodyType,
    CIScorecard | null | CiScenarioAggregationLevelOverviewError
  >,
  variables: SetOptional<CiScenarioAggregationLevelOverviewVariables, "query">,
  options: Parameters<typeof http.get>[2] = {},
) {
  const [path] = buildCiScenarioAggregationLevelOverviewQueryKey(variables);
  return http.get<
    {
      [K in keyof CiScenarioAggregationLevelOverviewVariables["path"]]: string;
    },
    DefaultBodyType,
    CIScorecard | null | CiScenarioAggregationLevelOverviewError
  >(path, handler, options);
}

export type CiScorecardDrilldownError = FetchError<HTTPValidationError>;

export type CiScorecardDrilldownVariables = {
  query?: never;
  path: { scenario: ClimateScenario; code: string; drilldownLevel: number };
};

function buildCiScorecardDrilldownQueryKey(
  variables: SetOptional<CiScorecardDrilldownVariables, "query">,
): [string] | [string, unknown] {
  const { scenario, code, drilldownLevel } = variables.path;
  const path = `/api/polaris/api/climate-scorecard/ci/v1/${scenario}/${code}/${drilldownLevel}/drilldown`;

  if (variables.query) {
    return [path, variables.query];
  }
  return [path];
}

/**
 * No description
 *
 * @name CiScorecardDrilldown
 * @summary Get Scorecard Ci Drilldown
 * @request GET:/climate-scorecard/ci/v1/{scenario}/{code}/{drilldown_level}/drilldown
 * @response `200` `CIScorecardDrilldown` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useQueryCiScorecardDrilldown(
  variables: CiScorecardDrilldownVariables,
  options: Omit<
    UseQueryOptions<CIScorecardDrilldown, CiScorecardDrilldownError>,
    "queryKey" | "queryFn"
  > &
    CustomQueryOptions<CIScorecardDrilldown> = {},
) {
  const accessToken = useAccessToken();
  const queryKey = buildCiScorecardDrilldownQueryKey(variables);
  const [path] = queryKey;
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useQuery<
    CIScorecardDrilldown,
    CiScorecardDrilldownError,
    CIScorecardDrilldown
  >({
    ...queryOptions,
    queryKey,
    queryFn: () =>
      fetcher<CIScorecardDrilldown>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
        ...fetcherOptions,
      }),
  });
}

/**
 * Hook to imperatively trigger the CiScorecardDrilldown query
 * @name CiScorecardDrilldown
 * @summary Get Scorecard Ci Drilldown
 * @request GET:/climate-scorecard/ci/v1/{scenario}/{code}/{drilldown_level}/drilldown
 * @response `200` `CIScorecardDrilldown` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useLazyQueryCiScorecardDrilldown(
  options: UseMutationOptions<
    CIScorecardDrilldown,
    CiScorecardDrilldownError,
    CiScorecardDrilldownVariables
  > &
    CustomQueryOptions<CIScorecardDrilldown> = {},
) {
  const accessToken = useAccessToken();
  const { headers, ...queryOptions } = options;
  const { mutate, mutateAsync, ...mutation } = useMutation({
    ...queryOptions,
    mutationFn: (variables: CiScorecardDrilldownVariables) => {
      const [path] = buildCiScorecardDrilldownQueryKey(variables);
      return fetcher<CIScorecardDrilldown>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        query: variables.query,
      });
    },
  });
  return {
    ...mutation,
    execute: mutate,
    executeAsync: mutateAsync,
  };
}

/**
 * Hook returning a function to invalidate data from `useQueryCiScorecardDrilldown` (e.g. after a mutation)
 *
 * query string variables are optional to allow inexact invalidation
 */
export function useInvalidateQueryCiScorecardDrilldown() {
  const queryClient = useQueryClient();
  return (variables: SetOptional<CiScorecardDrilldownVariables, "query">) =>
    queryClient.invalidateQueries({
      queryKey: buildCiScorecardDrilldownQueryKey(variables),
    });
}

/**
 * Hook returning a function to update the data for `useQueryCiScorecardDrilldown` (e.g. after a mutation)
 */
export function useUpdateQueryCiScorecardDrilldown() {
  const queryClient = useQueryClient();
  return (
    variables: CiScorecardDrilldownVariables,
    data:
      | CIScorecardDrilldown
      | undefined
      | ((
          oldData: CIScorecardDrilldown | undefined,
        ) => CIScorecardDrilldown | undefined),
  ) =>
    queryClient.setQueryData(
      buildCiScorecardDrilldownQueryKey(variables),
      data,
    );
}

/**
 * Returns a function that will mock the http request made in `useQueryCiScorecardDrilldown` using using nock.
 * Pass any query or path parameters as well as the mock response and status
 */
export function getMockCiScorecardDrilldown({
  variables,
  status,
  response,
}: {
  variables: CiScorecardDrilldownVariables;
  status: number;
  response: CIScorecardDrilldown | CiScorecardDrilldownError;
}): (scope: Scope) => Scope {
  const [path] = buildCiScorecardDrilldownQueryKey(variables);

  if (variables.query) {
    return (scope: Scope) => {
      return scope
        .get(path)
        .query(variables)
        .reply(status, response || undefined);
    };
  }

  return (scope: Scope) => {
    return scope.get(path).reply(status, response || undefined);
  };
}

/**
 * MSW mock handler for `useQueryCiScorecardDrilldown`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param variables Path/query parameters for the endpoint.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswCiScorecardDrilldown(
 *   ({ request }) => HttpResponse.json({ result: "ok" }),
 *   { path: { id: "123" }}
 * );
 */
export function getMockMswCiScorecardDrilldown(
  handler: HttpResponseResolver<
    { [K in keyof CiScorecardDrilldownVariables["path"]]: string },
    DefaultBodyType,
    CIScorecardDrilldown | null | CiScorecardDrilldownError
  >,
  variables: SetOptional<CiScorecardDrilldownVariables, "query">,
  options: Parameters<typeof http.get>[2] = {},
) {
  const [path] = buildCiScorecardDrilldownQueryKey(variables);
  return http.get<
    { [K in keyof CiScorecardDrilldownVariables["path"]]: string },
    DefaultBodyType,
    CIScorecardDrilldown | null | CiScorecardDrilldownError
  >(path, handler, options);
}

export type CreateCheckoutSessionError = FetchError<HTTPValidationError>;

export type CreateCheckoutSessionVariables = {
  query?: never;
  path?: never;
  body: CheckoutRequest;
};

/**
 * No description
 *
 * @name CreateCheckoutSession
 * @summary Create Checkout Session
 * @request POST:/climate-scorecard/v1/create-checkout-session
 * @response `200` `RedirectResponse` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useMutationCreateCheckoutSession(
  options: UseMutationOptions<
    RedirectResponse,
    CreateCheckoutSessionError,
    CreateCheckoutSessionVariables
  > &
    CustomQueryOptions<RedirectResponse> = {},
) {
  const accessToken = useAccessToken();
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useMutation<
    RedirectResponse,
    CreateCheckoutSessionError,
    CreateCheckoutSessionVariables
  >({
    ...options,
    mutationFn: (variables) => {
      const path = `/api/polaris/api/climate-scorecard/v1/create-checkout-session`;
      return fetcher<RedirectResponse>({
        url: path,
        query: variables.query,
        method: "POST",
        body: variables.body,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        ...fetcherOptions,
      });
    },
  });
}

/**
 * Returns a function that will mock the http request made in `useMutationCreateCheckoutSession` using nock.
 * Pass path parameters if necessary and optionally pass request body which will be verified using jest.
 */
export function getMockCreateCheckoutSession({
  variables,
  status,
  response = undefined,
}: {
  variables?: CreateCheckoutSessionVariables;
  status: number;
  response?: RedirectResponse | CreateCheckoutSessionError;
}): (scope: Scope) => Scope {
  const path = `/api/polaris/api/climate-scorecard/v1/create-checkout-session`;

  if (status === 204) {
    if (variables?.body) {
      return (scope: Scope) =>
        scope
          .post(path, (body) => {
            expect(body).toEqual(variables.body);
            return true;
          })
          .reply(status);
    }
    return (scope: Scope) => scope.post(path).reply(status);
  }

  if (variables?.body) {
    return (scope: Scope) =>
      scope
        .post(path, (body) => {
          expect(body).toEqual(variables.body);
          return true;
        })
        .reply(status, response === null ? undefined : response);
  }

  return (scope: Scope) =>
    scope.post(path).reply(status, response === null ? undefined : response);
}

/**
 * MSW mock handler for `useMutationCreateCheckoutSession`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswCreateCheckoutSession(
 *   ({ request }) => HttpResponse.json({ result: "ok" })
 * );
 */
export function getMockMswCreateCheckoutSession(
  handler: HttpResponseResolver<
    PathParams,
    CheckoutRequest,
    RedirectResponse | null | CreateCheckoutSessionError
  >,
  options: Parameters<typeof http.post>[2] = {},
) {
  const path = `/api/polaris/api/climate-scorecard/v1/create-checkout-session`;
  return http.post<
    PathParams,
    CheckoutRequest,
    RedirectResponse | null | CreateCheckoutSessionError
  >(path, handler, options);
}

export type CreateCustomerPortalSessionError = FetchError;

export type CreateCustomerPortalSessionVariables = {
  query?: never;
  path?: never;
  body?: never;
};

/**
 * No description
 *
 * @name CreateCustomerPortalSession
 * @summary Create Customer Portal Session
 * @request POST:/climate-scorecard/v1/create-customer-portal-session
 * @response `200` `RedirectResponse` Successful Response
 */
export function useMutationCreateCustomerPortalSession(
  options: UseMutationOptions<
    RedirectResponse,
    CreateCustomerPortalSessionError,
    CreateCustomerPortalSessionVariables
  > &
    CustomQueryOptions<RedirectResponse> = {},
) {
  const accessToken = useAccessToken();
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useMutation<
    RedirectResponse,
    CreateCustomerPortalSessionError,
    CreateCustomerPortalSessionVariables
  >({
    ...options,
    mutationFn: (variables) => {
      const path = `/api/polaris/api/climate-scorecard/v1/create-customer-portal-session`;
      return fetcher<RedirectResponse>({
        url: path,
        query: variables.query,
        method: "POST",
        body: variables.body,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        ...fetcherOptions,
      });
    },
  });
}

/**
 * Returns a function that will mock the http request made in `useMutationCreateCustomerPortalSession` using nock.
 * Pass path parameters if necessary and optionally pass request body which will be verified using jest.
 */
export function getMockCreateCustomerPortalSession({
  variables,
  status,
  response = undefined,
}: {
  variables?: CreateCustomerPortalSessionVariables;
  status: number;
  response?: RedirectResponse | CreateCustomerPortalSessionError;
}): (scope: Scope) => Scope {
  const path = `/api/polaris/api/climate-scorecard/v1/create-customer-portal-session`;

  if (status === 204) {
    if (variables?.body) {
      return (scope: Scope) =>
        scope
          .post(path, (body) => {
            expect(body).toEqual(variables.body);
            return true;
          })
          .reply(status);
    }
    return (scope: Scope) => scope.post(path).reply(status);
  }

  if (variables?.body) {
    return (scope: Scope) =>
      scope
        .post(path, (body) => {
          expect(body).toEqual(variables.body);
          return true;
        })
        .reply(status, response === null ? undefined : response);
  }

  return (scope: Scope) =>
    scope.post(path).reply(status, response === null ? undefined : response);
}

/**
 * MSW mock handler for `useMutationCreateCustomerPortalSession`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswCreateCustomerPortalSession(
 *   ({ request }) => HttpResponse.json({ result: "ok" })
 * );
 */
export function getMockMswCreateCustomerPortalSession(
  handler: HttpResponseResolver<
    PathParams,
    DefaultBodyType,
    RedirectResponse | null | CreateCustomerPortalSessionError
  >,
  options: Parameters<typeof http.post>[2] = {},
) {
  const path = `/api/polaris/api/climate-scorecard/v1/create-customer-portal-session`;
  return http.post<
    PathParams,
    DefaultBodyType,
    RedirectResponse | null | CreateCustomerPortalSessionError
  >(path, handler, options);
}

export type ConfigurationOptionsError = FetchError;

function buildConfigurationOptionsQueryKey(): [string] | [string, unknown] {
  const path = `/api/polaris/api/climate-scorecard/v1/configuration-options`;

  return [path];
}

/**
 * No description
 *
 * @name ConfigurationOptions
 * @summary Get Configuration Options
 * @request GET:/climate-scorecard/v1/configuration-options
 * @response `200` `ConfigurationOptions` Successful Response
 */
export function useQueryConfigurationOptions(
  options: Omit<
    UseQueryOptions<ConfigurationOptions, ConfigurationOptionsError>,
    "queryKey" | "queryFn"
  > &
    CustomQueryOptions<ConfigurationOptions> = {},
) {
  const accessToken = useAccessToken();
  const queryKey = buildConfigurationOptionsQueryKey();
  const [path] = queryKey;
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useQuery<
    ConfigurationOptions,
    ConfigurationOptionsError,
    ConfigurationOptions
  >({
    ...queryOptions,
    queryKey,
    queryFn: () =>
      fetcher<ConfigurationOptions>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        ...fetcherOptions,
      }),
  });
}

/**
 * Hook to imperatively trigger the ConfigurationOptions query
 * @name ConfigurationOptions
 * @summary Get Configuration Options
 * @request GET:/climate-scorecard/v1/configuration-options
 * @response `200` `ConfigurationOptions` Successful Response
 */
export function useLazyQueryConfigurationOptions(
  options: UseMutationOptions<
    ConfigurationOptions,
    ConfigurationOptionsError,
    void
  > &
    CustomQueryOptions<ConfigurationOptions> = {},
) {
  const accessToken = useAccessToken();
  const { headers, ...queryOptions } = options;
  const { mutate, mutateAsync, ...mutation } = useMutation({
    ...queryOptions,
    mutationFn: () => {
      const [path] = buildConfigurationOptionsQueryKey();
      return fetcher<ConfigurationOptions>({
        url: path,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
      });
    },
  });
  return {
    ...mutation,
    execute: mutate,
    executeAsync: mutateAsync,
  };
}

/**
 * Hook returning a function to invalidate data from `useQueryConfigurationOptions` (e.g. after a mutation)
 *
 * query string variables are optional to allow inexact invalidation
 */
export function useInvalidateQueryConfigurationOptions() {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: buildConfigurationOptionsQueryKey(),
    });
}

/**
 * Hook returning a function to update the data for `useQueryConfigurationOptions` (e.g. after a mutation)
 */
export function useUpdateQueryConfigurationOptions() {
  const queryClient = useQueryClient();
  return (
    data:
      | ConfigurationOptions
      | undefined
      | ((
          oldData: ConfigurationOptions | undefined,
        ) => ConfigurationOptions | undefined),
  ) => queryClient.setQueryData(buildConfigurationOptionsQueryKey(), data);
}

/**
 * Returns a function that will mock the http request made in `useQueryConfigurationOptions` using using nock.
 * Pass any query or path parameters as well as the mock response and status
 */
export function getMockConfigurationOptions({
  status,
  response,
}: {
  status: number;
  response: ConfigurationOptions | ConfigurationOptionsError;
}): (scope: Scope) => Scope {
  const [path] = buildConfigurationOptionsQueryKey();

  return (scope: Scope) => {
    return scope.get(path).reply(status, response || undefined);
  };
}

/**
 * MSW mock handler for `useQueryConfigurationOptions`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswConfigurationOptions(
 *   ({ request }) => HttpResponse.json({ result: "ok" })
 * );
 */
export function getMockMswConfigurationOptions(
  handler: HttpResponseResolver<
    PathParams,
    DefaultBodyType,
    ConfigurationOptions | null | ConfigurationOptionsError
  >,
  options: Parameters<typeof http.get>[2] = {},
) {
  const [path] = buildConfigurationOptionsQueryKey();
  return http.get<
    PathParams,
    DefaultBodyType,
    ConfigurationOptions | null | ConfigurationOptionsError
  >(path, handler, options);
}

export type CreateCustomerFreeTrialError = FetchError<HTTPValidationError>;

export type CreateCustomerFreeTrialVariables = {
  query?: never;
  path?: never;
  body: CreateTrialRequest;
};

/**
 * @description Create a free trial subscription for a customer.
 *
 * @name CreateCustomerFreeTrial
 * @summary Create Customer Free Trial
 * @request POST:/climate-scorecard/v1/create-trial-subscription
 * @response `201` `any` Successful Response
 * @response `422` `HTTPValidationError` Validation Error
 */
export function useMutationCreateCustomerFreeTrial(
  options: UseMutationOptions<
    any,
    CreateCustomerFreeTrialError,
    CreateCustomerFreeTrialVariables
  > &
    CustomQueryOptions<any> = {},
) {
  const accessToken = useAccessToken();
  const { headers, fetcherOptions, ...queryOptions } = options;

  return useMutation<
    any,
    CreateCustomerFreeTrialError,
    CreateCustomerFreeTrialVariables
  >({
    ...options,
    mutationFn: (variables) => {
      const path = `/api/polaris/api/climate-scorecard/v1/create-trial-subscription`;
      return fetcher<any>({
        url: path,
        query: variables.query,
        method: "POST",
        body: variables.body,
        queryStringFormat: QueryStringFormat.FORM_EXPLODE,
        headers: accessToken
          ? {
              Authorization: `Bearer ${accessToken}`,
              ...headers,
            }
          : headers,
        ...fetcherOptions,
      });
    },
  });
}

/**
 * Returns a function that will mock the http request made in `useMutationCreateCustomerFreeTrial` using nock.
 * Pass path parameters if necessary and optionally pass request body which will be verified using jest.
 */
export function getMockCreateCustomerFreeTrial({
  variables,
  status,
  response = undefined,
}: {
  variables?: CreateCustomerFreeTrialVariables;
  status: number;
  response?: any | CreateCustomerFreeTrialError;
}): (scope: Scope) => Scope {
  const path = `/api/polaris/api/climate-scorecard/v1/create-trial-subscription`;

  if (status === 204) {
    if (variables?.body) {
      return (scope: Scope) =>
        scope
          .post(path, (body) => {
            expect(body).toEqual(variables.body);
            return true;
          })
          .reply(status);
    }
    return (scope: Scope) => scope.post(path).reply(status);
  }

  if (variables?.body) {
    return (scope: Scope) =>
      scope
        .post(path, (body) => {
          expect(body).toEqual(variables.body);
          return true;
        })
        .reply(status, response === null ? undefined : response);
  }

  return (scope: Scope) =>
    scope.post(path).reply(status, response === null ? undefined : response);
}

/**
 * MSW mock handler for `useMutationCreateCustomerFreeTrial`.
 *
 * Pass a handler function to mock the response for this endpoint.
 *
 * @param handler   MSW handler function that returns a mocked response.
 * @param options   Optional MSW handler options.
 *
 * @example
 * getMockMswCreateCustomerFreeTrial(
 *   ({ request }) => HttpResponse.json({ result: "ok" })
 * );
 */
export function getMockMswCreateCustomerFreeTrial(
  handler: HttpResponseResolver<
    PathParams,
    CreateTrialRequest,
    any | null | CreateCustomerFreeTrialError
  >,
  options: Parameters<typeof http.post>[2] = {},
) {
  const path = `/api/polaris/api/climate-scorecard/v1/create-trial-subscription`;
  return http.post<
    PathParams,
    CreateTrialRequest,
    any | null | CreateCustomerFreeTrialError
  >(path, handler, options);
}
